import { generatePath, matchPath, useLocation } from 'react-router-dom'
import { TODOS_PATH } from 'paths'
import { getTotalCountFromInfiniteQuery } from 'utils/query'
import { NavItem } from 'components/NavItem'
import { TASKS_ALL_NAMESPACE, useWorkspaceTasks } from 'screens/Todos/hooks/useWorkspaceTasks'
import { useReviewsTodosChannel } from 'hooks/useReviewsTodosChannel'
import { Workspace } from 'types'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Approval, ApprovalFilled } from 'blaze-ui/icons'

interface Props {
  workspace: Workspace
  onPress: () => void
}

const NavMenuTodosItem = ({ workspace, onPress }: Props) => {
  const location = useLocation()
  const allTodosAssignedQuery = useWorkspaceTasks({
    namespace: TASKS_ALL_NAMESPACE,
    workspaceId: workspace.key,
    filters: { request_state: 'open', types: [], role: 'assignee', review_state: 'pending', todo_state: 'incomplete' },
    items: 1,
  })
  useReviewsTodosChannel()

  return (
    <NavMenuItem
      icon={Approval}
      activeIcon={ApprovalFilled}
      to={generatePath(TODOS_PATH, { workspaceId: workspace.id })}
      onPress={onPress}
      label={'Approvals'}
    >
      <NavItem.Counter
        total={getTotalCountFromInfiniteQuery(allTodosAssignedQuery)}
        isActive={
          !!matchPath(location.pathname, {
            path: TODOS_PATH,
            exact: true,
          })
        }
      />
    </NavMenuItem>
  )
}

export { NavMenuTodosItem }
